<template>
  <div class="qualityManual-container-office">
    <vab-only-office v-if="hasFile" id="office-preview" :documentServerUrl="documentServerUrl" :config="config"
      @load="initFrame" />
    <application ref="docApplication" type="onlyoffice" :edit="edit" :fileId="fileInfo.fileId" @viewOffice="viewOffice" @editOffice="editOffice" @addComment="addComment" @getCommentPosition="getCommentPosition"
      @removeComment="removeComment" />
  </div>
</template>
<script>
import { creatWatermarkUserInfo, addWaterMarker } from "@/CommonDP/mongeView/utils";
import vabOnlyOffice from "./index.vue";
import Guid from "guid";
import application from "@/CommonDP/mongeView/application.vue";
import mongeService from '../service/monge-service';
import { getToken } from "@/CommonDP/mongeView/utils";
export default {
  components: { vabOnlyOffice, application },
  props: {
    fileInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      documentServerUrl: "", // documentServerUrl.href,
      config: {
        lang: "zh-CN",
        document: {
          fileType: "",
          key: Guid.raw(),
          title: "",
          lang: "zh-CN",
          url: "",
          permissions: {
            edit: false,
            comment: true
          }
        },
        editorConfig: {
          lang: "zh-CN",
          mode: "edit",
          callbackUrl: "", // callback.href,
          customization: {
            hideRightMenu: false, // 定义在第一次加载时是显示还是隐藏右侧菜单。默认值为false。
            autosave: false, // 定义是启用还是禁用“自动保存”菜单选项。请注意，如果您在菜单中更改此选项，它将被保存到浏览器的localStorage中。默认值为true。
            forcesave: true, // 定义保存按钮是否显示默认false
            chat: false, // 定义“聊天”菜单按钮是显示还是隐藏；请注意，如果您隐藏“聊天”按钮，则相应的聊天功能也将被禁用。默认值为true。
            commentAuthorOnly: false, // 定义用户是否只能编辑和删除他的评论。默认值为false。
            comments: true, // 定义是显示还是隐藏“注释”菜单按钮；请注意，如果您隐藏“评论”按钮，则相应的评论功能将仅可用于查看，评论的添加和编辑将不可用。默认值为true。
            compactHeader: false, // 定义是否将菜单栏放在在徽标旁边使界面更加紧凑默认false。
            compactToolbar: false, // 定义显示的顶部工具栏类型是完整（false）还是紧凑true。默认值为false 多余菜单将在右侧折叠点击显示。
            compatibleFeatures: false, // 定义仅与OOXML格式兼容的功能的使用。例如，不要在整个文档上使用注释。默认值为false。
            macros: true, // 定义是否将运行文档宏以及可用的宏设置。默认值为true。
            macrosMode: "warn", // 定义是否将运行文档宏。可以采用以下值： disable -根本不运行；enable -自动运行所有宏；warn -警告宏并请求允许运行。默认值为original。
            plugins: false, // 定义是否将启动插件并可用。默认值为true。
            showReviewChanges: false, // 定义在加载编辑器时是否自动显示或隐藏审阅更改面板。默认值为false。
            spellcheck: true, // 定义在加载编辑器时是否自动打开或关闭拼写检查器。拼写检查器仅适用于文档编辑器和演示文稿编辑器。默认值为true。
            toolbarNoTabs: false, // 定义是突出显示顶部工具栏选项卡样式。默认值为false。
            unit: "cm", // 定义在标尺和对话框中使用的度量单位。可以采用以下值：cm -厘米，pt-点，inch -英寸。默认值为厘米（cm）。
            zoom: 100 // 定义以百分比为单位的文档显示缩放值。可以取大于0的值。对于文本文档和演示文稿，可以将此参数设置为-1（使文档适合页面选项）或-2（使文档页面宽度适合编辑器页面）。默认值为100。
          }
        }
      },
      docloaded: false,
      actionData: {
        isMini: true
      },
      showAllList: [],
      hasFile: false,
      edit: "view"
    };
  },
  watch: {
    "fileInfo.fileId": function() {
      this.initConfig();
    }
  },

  mounted() {
    window.addEventListener("message", (event) => {
      const data = event.data;
      if (data.cmd === "showComment") {
        localStorage.setItem('commentQuote', data.data);
        const item = {};
        item.id = "issue";
        this.$refs.docApplication.openFun(item, 1, true);
      }
    });
  },
  methods: {
    async initConfig() {
      if (!this.fileInfo?.fileId) {
        return;
      }
      const { fileId, fileVersion } = this.fileInfo;
      const { data } = await mongeService.getFileDetails(fileId, this.fileInfo.i);
      const index = data.fileName.lastIndexOf(".");
      // 获取 office 文件的下载地址, 并给参数赋值
      const res = await mongeService.getonlyoffice(fileId, fileVersion);
      this.config.document.fileType = data.fileName.substring(index+1);
      this.config.document.title = this.fileInfo.title;
      this.config.document.url = res.data || "";

      const { VUE_APP_HOST, VUE_APP_API } = process.env;
      let VUE_APP_ONLY_OFFICE_HOST = process.env.VUE_APP_ONLY_OFFICE_HOST;
      if (!VUE_APP_ONLY_OFFICE_HOST) {
        VUE_APP_ONLY_OFFICE_HOST = VUE_APP_HOST;
      }
      let appApi = VUE_APP_API+ "/";
      // 构造文档的保存地址
      const callback = new URL("wopi/files/onlyoffice/save", new URL(appApi, new URL(`${VUE_APP_HOST}`, location.origin)));
      callback.searchParams.set("fileId", fileId);
      callback.searchParams.set("token", getToken());
      this.config.editorConfig.callbackUrl = callback.href;
      // 构造 onlyoffice 预览服务的地址
      const documentServerUri = new URL(VUE_APP_ONLY_OFFICE_HOST, location.origin);
      this.documentServerUrl = documentServerUri.href;
      await this.$nextTick();
      // 启用预览
      this.hasFile = true;
    },

    async initFrame() {
      await this.$nextTick();
      const domBox = window.frames["frameEditor"];
      if (!domBox) {
        this.$error("预览服务加载异常");
        return;
      }
      domBox.addEventListener("error", () => {
        this.loadingTxt = "文档加载失败";
      });
      domBox.addEventListener("load", () => {
        this.loading = false;
        this.docloaded = true;
        addWaterMarker(document.body, creatWatermarkUserInfo());
      });
    },
    editOffice(){
      this.config.document.permissions.edit = true;
      this.config.editorConfig.callbackUrl = this.config.editorConfig.callbackUrl +"&saveMode=1";
      this.config.editorConfig.customization.autosave = false;
      this.edit = "edit";
    },
    viewOffice(){
      this.config.document.permissions.edit = false;
      this.config.editorConfig.callbackUrl = this.config.editorConfig.callbackUrl.split("&saveMode=1")[0];
      this.config.editorConfig.customization.autosave = false;
      this.edit = "view";
    },
    addComment(data, createFlag) {
      console.log("syncComment office-----");
      window.frames["frameEditor"].postMessage(
        {
          cmd: "syncComment",
          data: data,
          createFlag: createFlag
        },
        "*"
      );
    },
    getCommentPosition(data, quote) {
      console.log("getCommentPosition office-----");
      console.log(quote);
      window.frames["frameEditor"].postMessage(
        {
          cmd: "getPosition",
          data: data,
          quote: quote
        },
        "*"
      );
    },
    removeComment() {
      console.log("removeComment office-----");
      window.frames["frameEditor"].postMessage(
        {
          cmd: "removeComment"
        },
        "*"
      );
    },
    getCommentPositionTest() {
      console.log("getCommentPositionTest office-----");
      window.frames["frameEditor"].postMessage(
        {
          cmd: "getPositionTest",
          data: "2301"
        },
        "*"
      );
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.qualityManual-container-office {
  width: 100%;
  height: 100%;
}
</style>